// src/firebase/config.js
// Replace these values with your actual Firebase project config
// Get from: Firebase Console → Project Settings → Your Apps → Web App

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey           : process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain       : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  // Sign-in runs on the Firebase project applied-grove-397205-b3345 (the
  // API key and auth domain belong to it). The fax backend, Firestore and
  // Cloud Storage live in the separate Google Cloud project
  // applied-grove-397205.
  projectId        : 'applied-grove-397205-b3345',
  storageBucket    : process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId            : process.env.REACT_APP_FIREBASE_APP_ID,
};

const app      = initializeApp(firebaseConfig);
export const auth     = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Restrict Google Sign-in to allowed domains
googleProvider.setCustomParameters({ hd: '' }); // domain check done server-side

// 3.84.7: the app's Google button (hooks/useAuth.js). Google always asks which
// account, so nothing signs an app in without a click, even with a Google
// session in this browser. Microsoft already does.
export const appGoogleProvider = new GoogleAuthProvider();
appGoogleProvider.setCustomParameters({ hd: '', prompt: 'select_account' });

// 3.72.0 (owner, Oct 30): Microsoft sign-in (work Microsoft 365 and
// personal accounts; app "Crazy Pixels Fax Portal" in admin@'s Entra
// directory). Only for portal accounts that connected it in Security
// (the server refuses any other Microsoft sign-in).
export const microsoftProvider = new OAuthProvider('microsoft.com');
microsoftProvider.setCustomParameters({ prompt: 'select_account' });

export const ALLOWED_DOMAINS = ['espoc.com', 'clinicmind.com', 'crazypixels.org'];
export const API_BASE = process.env.REACT_APP_API_BASE || 'https://crazypixels-fax-975281709627.us-central1.run.app';

export default app;
